export const getCompanyNameByCountry = (country: string): string => {
  const companyNames: { [key: string]: string } = {
    US: 'ZOE',
    UK: 'ZOE Limited',
  }
  return companyNames[country] || 'ZOE Limited'
}
